export default "__VITE_ASSET__DIXcK9ke__"